import Constants from '../utils/consts';

var http = require('follow-redirects').https;
var fs = require('fs');
var qs = require('querystring');


export default async function getMeetingsService(uname, token, eventId) {
    return new Promise(function (resolve, reject) {

        var options = {
        'method': 'POST',
        'hostname': Constants.ipAddress,
        'path': '/apis/getMeetings.php',
        'headers': {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cookie': 'uid=e02675a1a7516909792f6850dffcd5fe'
        },
        'maxRedirects': 20
        };

        var req = http.request(options, function (res) {
        var chunks = [];

        res.on("data", function (chunk) {
            chunks.push(chunk);
        });

        res.on("end", function (chunk) {
            var body = Buffer.concat(chunks);
            console.log(body.toString());
            const resp = JSON.parse(body.toString());

            var meetings = [];

            for (var i = 0; i < resp.length; i++){
                
                let meetingId = resp[i].id;
                var indexFound = -1;

                for (var m = 0; m < meetings.length; m++){
                    if (meetings[m].id == meetingId){
                        indexFound = m;
                    }
                }
                if (indexFound == -1){
                    var meetingObj = resp[i];
                    meetingObj.investors = [];
                    meetingObj.investors.push({
                        id: meetingObj.investor_id,
                        name: meetingObj.i_name,
                        company: meetingObj.i_company,
                        broker: meetingObj.brokerInvestor,
                        brokerId: meetingObj.brokerInvestorId,
                        isAnalyst: meetingObj.isAnalyst
                    });
                    meetings.push(meetingObj);
                }
                else {
                    var meetingObj = meetings[indexFound];
                    meetingObj.investors.push({
                        id: resp[i].investor_id,
                        name: resp[i].i_name,
                        company: resp[i].i_company,
                        broker: resp[i].brokerInvestor,
                        brokerId: resp[i].brokerInvestorId,
                        isAnalyst: resp[i].isAnalyst
                    });
                    meetings[indexFound] = meetingObj;
                }
            }

            resolve(meetings);
        });

        res.on("error", function (error) {
            console.error(error);
        });
        });

        var postData = qs.stringify({
        'token': token,
        'uname': uname,
        'eventId': eventId,
        });

        req.write(postData);

        req.end();

        
    });
}
